class CartRemoveButton extends HTMLElement {
  constructor() {
    super()

    this.addEventListener('click', (event) => {
      event.preventDefault()
      this.closest('cart-items').updateQuantity(this.dataset.index, 0)
    })
  }
}
customElements.define('cart-remove-button', CartRemoveButton)

class CartItems extends HTMLElement {
  constructor() {
    super()

    this.lineItemStatusElement = document.getElementById(
      'shopping-cart-line-item-status'
    )
    this.cartErrors = document.getElementById('cart-errors')

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0)

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event)
    }, 300)

    this.addEventListener('change', this.debouncedOnChange.bind(this))
  }

  onChange(event) {
    if (event.target === null) return
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    )
  }

  getSectionsToRender() {
    let sections = [
      {
        id: 'mini-cart',
        section: document.getElementById('mini-cart')?.id,
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents'
      }
    ]
    if (document.querySelector('#main-cart-footer .free-shipping')) {
      sections.push({
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.free-shipping'
      })
    }
    return sections
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line)
    const sections = this.getSectionsToRender().map(
      (section) => section.section
    )

    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname
    })

    fetch(`${window.routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text()
      })
      .then((state) => {
        const parsedState = JSON.parse(state)
        this.classList.toggle('is-empty', parsedState.item_count === 0)
        const cartFooter = document.getElementById('main-cart-footer')

        if (cartFooter)
          cartFooter.classList.toggle('is-empty', parsedState.item_count === 0)
        if (parsedState.errors) {
          this.updateErrorLiveRegions(line, parsedState.errors)
        }
        this.getSectionsToRender().forEach((section) => {
          const element = document.getElementById(section.id)
          if (element) {
            const elementToReplace =
              element.querySelector(section.selector) || element

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              )
            }
          }
        })

        this.updateQuantityLiveRegions(line, parsedState.item_count)

        const lineItem = document.getElementById(`CartItem-${line}`)
        if (lineItem && name) lineItem.querySelector(`[name="${name}"]`).focus()
        this.disableLoading()

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: {
              cart: state
            }
          })
        )
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' })
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) =>
          overlay.classList.add('hidden')
        )
        this.disableLoading()
        if (this.cartErrors) {
          this.cartErrors.textContent = window.cartStrings.error
        }
      })
  }

  updateErrorLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`)
    if (lineItemError)
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message

    this.lineItemStatusElement.setAttribute('aria-hidden', true)

    const cartStatus =
      document.getElementById('cart-live-region-text') ||
      document.getElementById('CartDrawer-LiveRegionText')
    cartStatus.setAttribute('aria-hidden', false)

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true)
    }, 1000)
  }

  updateQuantityLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const quantityError = document.getElementById(`Line-item-error-${line}`)
      if (quantityError) {
        quantityError.querySelector('.cart-item__error-text').innerHTML =
          window.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          )
      }
    }

    this.currentItemCount = itemCount

    if (this.lineItemStatusElement)
      this.lineItemStatusElement.setAttribute('aria-hidden', true)

    const cartStatus = document.getElementById('cart-live-region-text')
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false)

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true)
      }, 1e3)
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML
  }

  enableLoading(line) {
    const cartItems = document.getElementById('main-cart-items')
    if (cartItems) cartItems.classList.add('cart__items--disabled')

    const loadingOverlay = this.querySelectorAll('.loading-overlay')[line - 1]
    if (loadingOverlay) loadingOverlay.classList.remove('hidden')

    document.activeElement.blur()
    if (this.lineItemStatusElement)
      this.lineItemStatusElement.setAttribute('aria-hidden', false)
  }

  disableLoading() {
    const cartItems = document.getElementById('main-cart-items')
    if (cartItems) cartItems.classList.remove('cart__items--disabled')
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id)

      if (element) {
        element.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        )
      }
    })
  }
}
customElements.define('cart-items', CartItems)

class CartNote extends HTMLElement {
  constructor() {
    super()

    this.addEventListener(
      'change',
      debounce((event) => {
        const body = JSON.stringify({ note: event.target.value })
        fetch(`${window.routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{ body }
        })
      }, 300)
    )
  }
}
customElements.define('cart-note', CartNote)

class DiscountCode extends HTMLElement {
  constructor() {
    super()

    if (isStorageSupported('session')) {
      this.setupDiscount()

      this.addEventListener('change', (event) => {
        window.sessionStorage.setItem('discount', event.target.value)
      })
    }
  }

  setupDiscount() {
    const discount = window.sessionStorage.getItem('discount')
    if (discount !== null) {
      this.querySelector('input[name="discount"]').value = discount
    }
  }
}

customElements.define('discount-code', DiscountCode)

class ShippingCalculator extends HTMLElement {
  constructor() {
    super()

    this.setupCountries()

    this.errors = this.querySelector('#ShippingCalculatorErrors')
    this.success = this.querySelector('#ShippingCalculatorSuccess')
    this.zip = this.querySelector('#ShippingCalculatorZip')
    this.country = this.querySelector('#ShippingCalculatorCountry')
    this.province = this.querySelector('#ShippingCalculatorProvince')
    this.button = this.querySelector('button')
    this.button.addEventListener('click', this.onSubmitHandler.bind(this))
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'ShippingCalculatorCountry',
        'ShippingCalculatorProvince',
        {
          hideElement: 'ShippingCalculatorProvinceContainer'
        }
      )
    }
  }

  onSubmitHandler(event) {
    event.preventDefault()

    this.errors.classList.add('hidden')
    this.success.classList.add('hidden')
    this.zip.classList.remove('invalid')
    this.country.classList.remove('invalid')
    this.province.classList.remove('invalid')
    this.button.classList.add('loading')
    this.button.setAttribute('disabled', true)

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value
      }
    })
    let sectionUrl = `${window.routes.cart_url}/shipping_rates.json`

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/')

    fetch(sectionUrl, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove('hidden')
          this.success.innerHTML = ''

          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement('p')
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`
            this.success.appendChild(child)
          })
        } else {
          let errors = []
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(
              `${attribute.charAt(0).toUpperCase() + attribute.slice(1)} ${
                messages[0]
              }`
            )
          })

          this.errors.classList.remove('hidden')
          this.errors.querySelector('.errors').innerHTML = errors.join('; ')
        }
      })
      .catch((e) => {
        console.error(e)
      })
      .finally(() => {
        this.button.classList.remove('loading')
        this.button.removeAttribute('disabled')
      })
  }
}

customElements.define('shipping-calculator', ShippingCalculator)

class CheckoutButton extends HTMLElement {
  constructor() {
    super()

    const url = window.location.hostname
    const pattern = /\.com$|\.ca$/i
    const isUSA = pattern.test(url)

    this.packaging = {
      compostableBag: 'WAK-BAG-1001-0',
      compostableBagBig: 'WAK-BAG-69114',
      miniBag: isUSA ? 'WAK-BAG-0003-1' : 'WAK-BAG-0001-1',
      mediumBag: 'WAK-BAG-0001-1',
      bigBag: 'WAK-BAG-0002-1',
      sticker: 'WAK-STI-0000-0',
      skus: {
        doNotUseCompostable:
          'WAK-BOOK,WAK-BOOK-001-2,WAK-BOOK-001-4,WAK-BOOK-001-5,WAK-COR-0001-0,WAK-COR-0002-0,WAK-HOO-EMB-0,WAK-NEE-',
        ballSkus:
          'WAK-BOU,WAK-BAM-,WAK-COT-,WAK-FIN-,WAK-PET-,WAK-WOO-,WAK-WAV-,WAK-MFI-,YLV-MEAL-,WAK-MSW-,YLV-ONLY-,TLV-ORCW-,WAK-DOU-,WAK-MEP-,WAK-FUZ-,WAK-SQU-,WAK-TOU-,WAK-BLI-,WAK-MIN-,WAK-REM-,YLV-LINN-,YLV-WOPA-',
        needleSkus: 'WAK-NEE-',
        otherSkus: 'WAK-BAG,WAK-BOX'
      },
      hs: {
        hs_bags: '4819400000',
        hs_stickers: '4911910040'
      }
    }
    this.packVolume = {
      'WAK-WOO': 1.0,
      'WAK-PET': 0.5,
      'WAK-MSW': 0.5,
      'WAK-MEP': 0.5,
      'WAK-SQU': 0.57,
      'WAK-MIN': 0.05,
      'WAK-FUZ': 0.4,
      'WAK-BOU': 0.57,
      'WAK-DOU': 0.44,
      'WAK-MFI': 0.25,
      'WAK-BAB': 0.24,
      'WAK-WAV': 0.44,
      'WAK-BLI': 0.25,
      'WAK-REM': 0.24,
      'WAK-COT': 0.27,
      'WAK-TWI': 0.2,
      'WAK-TOU': 0.27,
      'WAK-BAM': 0.18,
      'WAK-FIN': 0.31,
      'WAK-BRE': 0.22,
      'WAK-HAP': 0.31,
      'WAK-EGC': 0.31,
      'WAK-BAMB': 0.31,
      'WAK-MCO': 0.3,
      any: 0.5,
      'WAK-NEE-0001-0': 0,
      'WAK-NEE-0002-0': 0,
      'WAK-NEE-1005-0': 0.15,
      'WAK-NEE-1006-0': 0.15,
      'WAK-NEE-1008-0': 0.15,
      'WAK-NEE-1015-0': 0.15,
      'WAK-NEE-2003-0': 0.15,
      'WAK-NEE-2005-0': 0.15,
      'WAK-NEE-2006-0': 0.15,
      'WAK-NEE-2007-0': 0.15,
      'WAK-NEE-2015-0': 0.15,
      'WAK-NEE-ANC-0': 0.3,
      'WAK-NEE-CIR03-0': 0.3,
      'WAK-NEE-CIR04-0': 0.3,
      'WAK-NEE-CIR05-0': 0.3,
      'WAK-NEE-CIR06-0': 0.3,
      'WAK-NEE-CIR08-0': 0.3,
      'WAK-NEE-CIR15-0': 0.3,
      'WAK-NEE-EAT-0': 0.15,
      'WAK-NEE-EMB-0': 0,
      'WAK-NEE-KNI-0': 0.15,
      'WAK-NEE-LAT00-0': 0.15,
      'WAK-NEE-SIT-0': 0.15,
      'WAK-BAG-WIP': 0.55,
      'WAK-COM-0008-0': 0.25,
      'WAK-COM-0008-1': 0.25,
      'WAK-COM-0008-10': 0.25,
      'WAK-COM-0008-11': 0.25,
      'WAK-COM-0008-12': 0.25,
      'WAK-COM-0008-3': 0.25,
      'WAK-COM-0008-4': 0.25,
      'WAK-COM-0008-6': 0.25,
      'WAK-COM-0008-7': 0.25,
      'WAK-COM-0008-8': 0.25,
      'WAK-COM-0008-9': 0.25,
      'WAK-COM-NYC-0': 0.15,
      'WAK-COM-0021-11': 3.0,
      'WAK-GIF-0001-0': 1.48,
      'WAK-COM-0019-0': 1,
      'WAK-BOOK-001-2': 0.7,
      'WAK-COM-POM-0': 0.1,
      'WAK-COM-POM-1': 0.1,
      'WAK-COM-POM-2': 0.1,
      'WAK-COM-POM-3': 0.1,
      'WAK-COM-0003-6': 0.1,
      'WAK-COM-BRCT-5': 0.1,
      'WAK-COM-0003-4': 0.1,
      'WAK-COM-0021-17': 0.05,
      'WAK-COM-TTON-2': 0,
      'WAK-COM-TTON-1': 0,
      'WAK-COM-0021-4': 0.01,
      'WAK-COM-MKCH-0': 0.25,
      'WAK-COM-HAN-0': 0.25,
      'WAK-HOO': 1.5,
      'WAK-TSH': 0.25,
    }

    Object.freeze(this.packaging)
    Object.freeze(this.packVolume)
  }

  connectedCallback() {
    this.addEventListener('click', async (event) => {
      event.preventDefault()
      this.classList.add('loading')
      this.setAttribute('disabled', true)
      this.buildCartProperties()
    })
  }

  async buildCartProperties() {
    const bundles = []
    const packaging = []
    const orderProperties = { attributes: {} }
    const volume = {
      orderTotalVolume: 0,
      needlesQ: 0,
      isCompostable: true,
      fc: 1,
      nStickers: 1,
      hasKits: false
    }
  
    try {
      const { items } = await this.getCart()
    
      orderProperties.attributes.packaging = JSON.stringify([])
    
      let isBundle = items.some(item => item.properties._bundle)

      console.warn('BUNDLE: ', isBundle)
    
      items.forEach((item) => {
        if (item.properties._bundle) {
          if (!item.title.toLowerCase().includes('pack')) {
            volume.isCompostable = true
          }
          volume.hasKits = true
          const prop = {
            price: (item.price / 100).toFixed(2),
            id: item.id,
            sku: item.sku,
            title: item.title,
            quantity: item.quantity,
            bundle: JSON.parse(item.properties._bundle)
          }
          bundles.push(prop)
          if (!item.properties._packaging) {
            prop.bundle.forEach((bundleItem) => {
              this.calculateOrderVolume({
                item: bundleItem,
                volume,
                multiplier: item.quantity
              })
            })
          } else {
            const { packagingEntries } = this.transformStringOfPackaging(
              item.properties._packaging
            )
            packaging.push({
              bundle: item.sku,
              packaging: packagingEntries
            })
          }
        }
      })
    
      if (!isBundle) {
        items.forEach((item) => {
          if (!item.properties._bundle) {
            this.calculateOrderVolume({
              item,
              volume
            })
          }
        })
      }
    
      if (volume.orderTotalVolume > 0) {
        this.calculateOrderPackaging(packaging, volume)
      }
    
      orderProperties.attributes.bundles = JSON.stringify(bundles)
      orderProperties.attributes.packaging = JSON.stringify(packaging)
    
      await this.updateCart(orderProperties)
    } catch (e) {
      console.log(e)
    } finally {
      this.classList.remove('loading')
      this.removeAttribute('disabled')
      window.location.href = '/checkout'
    }
  }

  async getCart() {
    const res = await fetch('/cart.js', {
      method: 'GET',
      credentials: 'include'
    })
    return await res.json()
  }
  async updateCart(data) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
      keepalive: true
    })
    return res.json()
  }

  calculateOrderPackaging(packaging, volume) {
    if (volume.isCompostable && volume.orderTotalVolume <= 4) {
      return packaging.push({
        q: 1,
        sku: this.packaging.compostableBag,
        hs: this.packaging.hs.hs_bags
      })
    }

    const mergedObjs = {}
    this.calculatePackagingByVolume(volume.orderTotalVolume).forEach((obj) => {
      const sku = obj.sku
      !mergedObjs[sku]
        ? (mergedObjs[sku] = { ...obj })
        : (mergedObjs[sku].q += obj.q)
    })

    Object.values(mergedObjs).forEach((elem) => packaging.push(elem))
    return packaging
  }

  calculatePackagingByVolume(orderVolume) {
    let orderPackage
    let recursivePackage = []
    if (orderVolume < 2) {
      orderPackage = this.packaging.miniBag
    } else if (orderVolume >= 2 && orderVolume < 3) {
      orderPackage = this.packaging.mediumBag
    } else if (orderVolume >= 3 && orderVolume <= 6) {
      orderPackage = this.packaging.bigBag
    } else {
      orderPackage = this.packaging.bigBag
      recursivePackage = this.calculatePackagingByVolume(orderVolume - 6)
    }
    return [
      { q: 1, sku: orderPackage, hs: this.packaging.hs.hs_bags },
      { q: 1, sku: this.packaging.sticker, hs: this.packaging.hs.hs_stickers },
      ...recursivePackage
    ]
  }

  calculateOrderVolume({ item, volume, multiplier = 1 }) {
    const shortedSku = item.sku.split('-').slice(0, 2).join('-')
    const balls = this.packaging.skus.ballSkus
    const needles = this.packaging.skus.needleSkus
    const doNotUseCompostable = this.packaging.skus.doNotUseCompostable

    const q = item.quantity * multiplier

    if (doNotUseCompostable.includes(shortedSku)) {
      volume.isCompostable = false
    }
    if (this.packVolume[shortedSku]) {
      return (volume.orderTotalVolume += this.packVolume[shortedSku] * q)
    }
    if (this.packVolume[item.sku]) {
      return (volume.orderTotalVolume += this.packVolume[item.sku] * q)
    }
    // Volume balls
    if (balls.includes(shortedSku)) {
      volume.orderTotalVolume +=
        this.packVolume[shortedSku] * q || this.packVolume.any * q
    }
    // Volume Needles
    if (needles.includes(shortedSku)) {
      volume.orderTotalVolume +=
        this.packVolume[shortedSku] * q || this.packVolume.any * q
    }
  }

  transformStringOfPackaging(str) {
    const arr = str.split(',')
    const count = {}
    arr.forEach((item) => {
      count[item] = (count[item] || 0) + 1
    })
    return {
      packagingEntries: Object.entries(count).map(([sku, q]) => ({ sku, q }))
    }
  }
}
customElements.define('checkout-button', CheckoutButton)
